import { Component, OnInit } from '@angular/core';
import { MatDialog as MatDialog, MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { RegisterComponent } from '../register/register.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { UserDTO } from 'src/app/interfaces/user';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [MatToolbarModule, MatGridListModule, MatIconModule, RouterLink],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  role: string;
  user: UserDTO;
  isOk: boolean = false;
  isLoggedIn = false;
  oldsite: boolean = false;

  constructor(public matDialog: MatDialog, private tokenStorageService: TokenStorageService, private router: Router) { }

  ngOnInit(): void {

    this.isAuthorized();
  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.role = this.user.role;
      this.isOk = true;
      this.router.navigate(['dashboard']);
    }
  }

  registerModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "300px";
    dialogConfig.width = "480px";
    const modalDialog = this.matDialog.open(RegisterComponent, dialogConfig);
  }

  scrollToFeatures() {
    const targetElement = document.getElementById('why-section');
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
